import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  button: {
    id: 'views.TeamOfExpertsView.EmployeeList.button',
    defaultMessage: 'Dołącz do naszego zespołu'
  }
});



// WEBPACK FOOTER //
// ./src/views/TeamOfExperts/components/EmployeesList/EmployeeList.intl.js